<template>
  <div id="login">
    <section class="bannerprincipal pb-2">
      <SiteNav></SiteNav>
      <div
        class="col-12 text-center py-3"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        <div class="row"></div>
      </div>
    </section>

    <div class="text-center mt-5 py-5" data-aos="fade-up" data-aos-delay="600">
      <p class="fXG py-5 amarillo">&nbsp;</p>
    </div>

    <div class="container-fluid bgblanco py-3">
      <!-- <div class="row pb-5">
        <div class="col-12 blockd fG amarillo">Semana 1</div>
      </div>-->

      <div class="row">
        <div class="col-12 col-lg-6 pt-5">
          <form @submit="signup($event)" class="r15">
            <div class="col-12 text-left pt-1 pt-md-0 pb-4 mt-n4">
              <p class="fXG2 pb-2 morado bold">Edición de Registro</p>
            </div>
            <div class="col-12">
              <div class="row pb-4">
                <div class="col-lg-12 pb-0">
                  <!-- <div class="blanco fG">Nombre</div> -->
                  <input
                    v-model.trim="signupForm.nombre"
                    type="text"
                    placeholder="Nombre(s)*"
                    @input="
                      signupForm.nombre = $event.target.value.toUpperCase();
                      signupForm.nombre = quitarAcentos(signupForm.nombre);
                    "
                    required
                  />
                </div>

                <div class="col-lg-12 pb-0">
                  <!-- <div class="blanco fG">Apellido</div> -->
                  <input
                    v-model.trim="signupForm.apellido_paterno"
                    type="text"
                    placeholder="Apellido Paterno*"
                    @input="
                      signupForm.apellido_paterno =
                        $event.target.value.toUpperCase();
                      signupForm.apellido_paterno = quitarAcentos(
                        signupForm.apellido_paterno
                      );
                    "
                  />
                </div>
                <div class="col-lg-12 pb-0">
                  <!-- <div class="blanco fG">Apellido</div> -->
                  <input
                    v-model.trim="signupForm.apellido_materno"
                    type="text"
                    placeholder="Apellido Materno*"
                    @input="
                      signupForm.apellido_materno =
                        $event.target.value.toUpperCase();
                      signupForm.apellido_materno = quitarAcentos(
                        signupForm.apellido_materno
                      );
                    "
                  />
                </div>
                <div class="col-lg-12 pb-0">
                  <!-- <div class="blanco fG">Apellido</div> -->
                  <input
                    v-model.trim="signupForm.empresa"
                    type="text"
                    placeholder="Empresa*"
                    @input="
                      signupForm.empresa = $event.target.value.toUpperCase();
                      signupForm.empresa = quitarAcentos(signupForm.empresa);
                    "
                    required
                  />
                </div>
                <div class="col-lg-12 pb-0">
                  <!-- <div class="blanco fG">Apellido</div> -->
                  <input
                    v-model.trim="signupForm.puesto"
                    type="text"
                    placeholder="Puesto*"
                    @input="
                      signupForm.puesto = $event.target.value.toUpperCase();
                      signupForm.puesto = quitarAcentos(signupForm.puesto);
                    "
                    required
                  />
                </div>
                <div class="col-lg-12 pb-0">
                  <!-- <div class="blanco fG">Apellido</div> -->
                  <input
                    v-model.trim="signupForm.email_user"
                    type="email"
                    placeholder="Correo Electrónico*"
                    @input="
                      signupForm.email_user = $event.target.value.toLowerCase();
                      signupForm.email_user = quitarAcentos(
                        signupForm.email_user
                      );
                    "
                    required
                  />
                </div>
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-9 pb-0">
                      <!-- <div class="blanco fG">Correo Electrónico</div> -->
                      <!-- <select v-model="signupForm.codigo_pais" required>
                          <option value="">Código País</option>

                          <option value="+52">MÉXICO +52</option>
                          <option value="+1">ESTADOS UNIDOS +1</option>
                          <option value="+1">CANADÁ +1</option>
                          <option value="+55">BRASIL +55</option>
                        </select> -->
                      <input
                        v-model.trim="signupForm.telefono"
                        type="number"
                        placeholder="Teléfono"
                        maxlength="10"
                      />
                    </div>

                    <div class="col-3 pb-0">
                      <input
                        v-model.trim="signupForm.ext"
                        type="number"
                        placeholder="Ext."
                        maxlength="10"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 pb-0">
                  <!-- <div class="blanco fG">Apellido</div> -->
                  <input
                    v-model.trim="signupForm.movil"
                    type="number"
                    placeholder="Celular*"
                    maxlength="10"
                    required
                  />
                  <p class="negro">
                    <b>IMPORTANTE:</b> En este número de celular el asistente
                    recibirá notificaciones en tiempo real durante el evento.
                  </p>
                </div>
              </div>

              <div class="row pb-5">
                <div class="col-12 text-center">
                  <button
                    type="submit"
                    class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                  >
                    Actualizar
                  </button>
                </div>
              </div>
            </div>
            <!-- <div class="extras text-center">
                    <a @click="toggleForm()" class="pointer"
                      >Regresar al Login</a
                    >
                  </div> -->
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
    </div>

    <!-- <Glyphicons></Glyphicons> -->

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 42;
import Footer from "@/components/Footer";
// import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SiteNav from "@/components/SiteNav2";


import * as moment from "moment";

import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    //Footer,
    SiteNav,
    // Glyphicons,
  },
  data() {
    return {
      reenvioForm: {
        codigo: "",
      },

      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        id: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
      },

      columnsRegistros: [
        "asistira_al_evento",
        "tipo",
        "codigo_qr",
        "nombre",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email",
        "telefono",
        "movil",
        "terminos",
        "asistio",
        "fecha_asistio",
        "email_operador",
        "timestamp",
      ],
      columnsInvitados: [
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email",
        "telefono",
        "movil",
      ],
      columnsSolicitudes: [
        "no_cliente",
        "nombre",
        "apellido",
        "email",
        "estado",
        "FechaRegistro",
      ],
      data: null,
      options: {
        perPage: 100,
        headings: {
          tipo: "Tipo de registro",
          asistira_al_evento: "Asistirá al evento",
          email_operador: "Usuario que registró QR",
          cubrebocas: "Cubrebocas entregado",
          guantes: "Guantes entregado",
          kit_bienvenida: "Kit Bienvenida entregado",
          top: "Playera entregada",
          pulsera: "Pulsera entregada",
          asistio: "Asistió al evento",
          talla_tops: "Talla Playera",
          timestamp: "Fecha de registro en sistema",
        },
        editableColumns: [],
        sortable: [],
      },

      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: [],
      },
      tickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      centros: [],
      registros: [],
      invitados: [],
      user: null,
      contador_clinica: 0,
      contador_torneo: 0,
      contador_comida: 0,

      tope_clientes_se: 900,
      tope_equipo_prosa: 70,
      tope_staff_rp: 7,
      tope_patrocinios: 135,
      tope_medios: 20,
      tope_talks_2_code: 3,
      tope_ponentes: 32,

      clientes_se: 0,
      equipo_prosa: 0,
      staff_rp: 0,
      patrocinios: 0,
      medios: 0,
      talks_2_code: 0,
      ponentes: 0,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.user = JSON.parse(localStorage.getItem("user_foroprosa_2023"));

    this.getRegistro();
  },
  methods: {
    quitarAcentos(elemento) {
      //console.log('quitando acentos')
      elemento = elemento.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      //console.log({elemento})
      return elemento;
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    async changeStatusAsistenciaEvento(nombre, email, codigo_qr, status) {
      console.log({ changeStatusCodigo: codigo_qr });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        nombre: nombre,
        email: email,
        codigo_qr: codigo_qr,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusAsistenciaEvento.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async reenviarInvitacionQR(id) {
      console.log({ reenviarinvitacionqr: id });

      this.$store.dispatch("showLoader", true);

      var qData = {
        id: id,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res reenvio");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire(
                "Oops",
                "Hubo un problema al momento de reenviar el código QR, por favor intenta de nuevo.",
                "warning"
              );
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTipoRegistro(id, email, status) {
      console.log({ changeStatusTipoRegistro: id });

      //revisar el tope antes de continuar
      if (status != "") {
        let temp_count = 0;
        let temp_tope = 0;
        switch (status) {
          case "Clientes & SE":
            temp_count = this.clientes_se;
            temp_tope = this.tope_clientes_se;
            break;
          case "Equipo Prosa":
            temp_count = this.equipo_prosa;
            temp_tope = this.tope_equipo_prosa;
            break;
          case "Staff Comm & RP":
            temp_count = this.staff_rp;
            temp_tope = this.tope_staff_rp;
            break;
          case "Patrocinios":
            temp_count = this.patrocinios;
            temp_tope = this.tope_patrocinios;
            break;
          case "Medios":
            temp_count = this.medios;
            temp_tope = this.tope_medios;
            break;
          case "Ponente":
            temp_count = this.ponentes;
            temp_tope = this.tope_ponentes;
            break;
          case "Talks 2 Code":
            temp_count = this.talks_2_code;
            temp_tope = this.tope_talks_2_code;
            break;
        }

        if (temp_count >= temp_tope) {
          swal.fire(
            "Operación no realizada",
            "Se ha llegado al tope máximo para este tipo de registro.",
            "warning"
          );

          return;
        }
      }

      this.$store.dispatch("showLoader", true);

      var qData = {
        id: id,
        email: email,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTipoRegistro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res reenvio");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              swal.fire("Bien", res.msg, "success");

              for (var i = 0; i < this.registros.length; i++) {
                if (this.registros[i].id === id) {
                  this.registros[i].tipo = status;
                }
              }

              this.cuentaRegistros();
            } else {
              swal.fire(
                "Oops",
                "Hubo un problema al momento de intentar actualizar el tipo de registro, intenta más tarde.",
                "warning"
              );
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusComida(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusComida.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTorneo(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTorneo.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusClinica(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusClinica.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTalla(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTalla.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusGuantes(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusGuantes.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusHorarioClinica(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusHorarioClinica.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusCubrebocas(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusCubrebocas.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    getInvitados() {
      console.log("get invitados");

      const https = require("https");
      var qData = {
        // id: this.user.no_cliente,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getInvitados.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.invitados = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    getRegistro() {
      console.log("get registros");

      const https = require("https");
      var qData = {
        id: this.$route.params.id,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistroAdmin.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.signupForm.id = this.$route.params.id;
              this.signupForm.nombre = res.datos[0].nombre;
              this.signupForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.signupForm.apellido_materno = res.datos[0].apellido_materno;
              this.signupForm.empresa = res.datos[0].empresa;
              this.signupForm.puesto = res.datos[0].puesto;
              this.signupForm.email_user = res.datos[0].email;
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;
              this.signupForm.ext = res.datos[0].ext;

              this.cuentaRegistros();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    cuentaRegistros() {
      this.clientes_se = 0;
      this.equipo_prosa = 0;
      this.staff_rp = 0;
      this.patrocinios = 0;
      this.medios = 0;
      this.talks_2_code = 0;
      this.ponentes = 0;

      for (var i = 0; i < this.registros.length; i++) {
        if (this.registros[i].tipo == "Clientes & SE") {
          this.clientes_se++;
        }
        if (this.registros[i].tipo == "Equipo Prosa") {
          this.equipo_prosa++;
        }
        if (this.registros[i].tipo == "Staff Comm & RP") {
          this.staff_rp++;
        }
        if (this.registros[i].tipo == "Patrocinios") {
          this.patrocinios++;
        }
        if (this.registros[i].tipo == "Medios") {
          this.medios++;
        }
        if (this.registros[i].tipo == "Ponente") {
          this.ponentes++;
        }
        if (this.registros[i].tipo == "Talks 2 Code") {
          this.talks_2_code++;
        }
      }
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              //this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1;
              this.signupForm.nombre_2 = res.datos[0].nombre_2;
              this.signupForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.signupForm.apellido_materno = res.datos[0].apellido_materno;
              this.signupForm.empresa = res.datos[0].empresa;
              this.signupForm.puesto = res.datos[0].puesto;
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              this.reenvioForm.codigo = "";

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "edicionRegistroXAdmin.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              swal
                .fire({
                  title: "Bien",
                  html: res.msg,
                  icon: "success",
                  confirmButtonText: "Ok"
                })
                .then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    this.$router.push('/administrador/dashboard/')
                  }
                });
              //this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signupInvitado(e) {
      e.preventDefault();
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registroInvitadoXAdmin.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.talla_cubrebocas = "";
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.horario_clinica = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_guantes = "";
      }
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
      };
    },
  },
};
</script>

